import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'containerSizeFilter'
})
export class ContainerSizeFilter implements PipeTransform {
  transform(products: any[], containerSize: string, nurseryProducts: any[], nurseryProductDetailed: any[]) {
    // console.log('containerSizeFilter', nurseryProductDetailed, containerSize);
    if (!containerSize) {
      return products;
    }

    return products.filter(p => {
      const nurseryProduct = nurseryProducts.find(np => np.product_id === p.id);
      if (!nurseryProduct) {
        return false;
      }
      const details = nurseryProductDetailed.find(pd => pd.nursery_product_id === nurseryProduct.id);
      const predicate = details.container_size.indexOf(containerSize) >= 0;
      if (predicate) {
        // console.log(details.container_size, containerSize);
      }
      return predicate;
    });
  }
}